import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './locales/resources';
import LanguageDetector from "i18next-browser-languagedetector";
import 'moment/locale/ja';
import moment from 'moment';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {escapeValue: false}
  }).then(() => {
    moment.locale(i18n.language);
  }
);
moment.updateLocale('en', {
  longDateFormat: {
    L: "MM/DD/YYYY",
    LL: "MMMM D, YYYY",
    LLL: "MMMM D, YYYY h:mm A",
    LLLL: "dddd, MMMM D, YYYY h:mm A",
    LT: "h:mm A",
    LTS: "h:mm:ss A",
    // llll: "ddd, MMM D, YYYY h:mm A",
    llll: "ddd, MMM D, YYYY",//Change format
  }
});

moment.updateLocale('ja', {
  longDateFormat : {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'YYYY/MM/DD',
    LL: 'YYYY年M月D日',
    LLL: 'YYYY年M月D日 HH:mm',
    LLLL: 'YYYY年M月D日 dddd HH:mm',
    LLLLL: 'YYYY年M月D日 dddd',
    l: 'YYYY/MM/DD',
    ll: 'YYYY年M月D日',
    lll: 'YYYY年M月D日 HH:mm',
    // llll: 'YYYY年M月D日(ddd) HH:mm',
    llll: 'YYYY年M月D日(ddd)',//Change format
  }
});
